function Person({sx={}}) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none" {...sx}>
            <path
                d="M9 12.125H5.625C4.57833 12.125 4.05499 12.125 3.62914 12.2542C2.67034 12.545 1.92003 13.2953 1.62918 14.2541C1.5 14.68 1.5 15.2033 1.5 16.25M12 14L13.5 15.5L16.5 12.5M10.875 6.125C10.875 7.98896 9.36396 9.5 7.5 9.5C5.63604 9.5 4.125 7.98896 4.125 6.125C4.125 4.26104 5.63604 2.75 7.5 2.75C9.36396 2.75 10.875 4.26104 10.875 6.125Z"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export { Person };
